<h2 mat-dialog-title>CHANGE DELIVERY LOCATION</h2>

<mat-dialog-content class="mat-typography">
    We would have to rebuild your cart on changing the delivery location.
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button btn-border style="margin-left: 15px;" (click)="close('cancel')">CANCEL</button>
    <button btn-primary (click)="close('proceed')" cdkFocusInitial style="margin-left: 15px;">PROCEED</button>
</mat-dialog-actions>
